// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3ZmoF","search":"Settings_search__27U0W","filter":"Settings_filter__3QJKN"};